var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2691 11.8052L12.5792 6.4962C12.6648 6.40988 12.7259 6.32735 12.7625 6.24862C12.7985 6.1692 12.8164 6.08633 12.8164 6C12.8164 5.91367 12.7985 5.8308 12.7625 5.75138C12.7259 5.67265 12.6648 5.59012 12.5792 5.5038L7.22663 0.129489C7.1403 0.043163 7.04327 0 6.93554 0C6.82711 0 6.72283 0.0576656 6.62269 0.172997C6.53567 0.273826 6.49596 0.381906 6.50356 0.497238C6.51047 0.611878 6.55708 0.712362 6.64341 0.798688L11.4127 5.54627H1.24838C1.14755 5.54627 1.05052 5.59323 0.95729 5.68715C0.863367 5.78039 0.816405 5.88467 0.816405 6C0.816405 6.11533 0.863367 6.21616 0.95729 6.30249C1.05052 6.38881 1.14755 6.43197 1.24838 6.43197H11.4127L6.62269 11.2231C6.53567 11.3094 6.49217 11.3992 6.49217 11.4924C6.49217 11.5863 6.54258 11.6906 6.64341 11.8052C6.74424 11.9061 6.84852 11.9565 6.95625 11.9565C7.06468 11.9565 7.16896 11.9061 7.2691 11.8052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.df1699018d2099b57ad1a663e77b289e.svg";
export { ForwardRef as ReactComponent };